import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDiscord,
  faInstagram,
  faTiktok,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { Container } from "../../components/container/container.layout";
import * as S from "./footer.styles";
import { Link } from "react-router-dom";
import { Logo } from "../logo/logo";
import { useStoreConfig } from "../../hooks/use-store-config";

export const Footer = () => {
  const { trustPilot, socials } = useStoreConfig();

  return (
    <S.FooterWrapper>
      <Container>
        <S.ContentWrapper>
          <S.Left>
            <Logo />
            <p>
              Aqui você encontra tudo para deixar sua experiência de jogo ainda
              melhor.
              <br />
              Compra rápida, segura e 100% digital. Explore e aproveite!
            </p>
            <p>
              E-mail para contato: <strong>contato@howstore.gg</strong>
            </p>
            <S.Socials>
              <a
                href={socials.discord}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Ir para o servidor do Discord da HowStore"
              >
                <FontAwesomeIcon icon={faDiscord} />
              </a>
              <a
                href={socials.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Ir para o Instagram da HowStore"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                href={socials.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Ir para o TikTok da HowStore"
              >
                <FontAwesomeIcon icon={faTiktok} />
              </a>
              <a
                href={socials.twitter}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Ir para o Twitter da HowStore"
              >
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
              <a
                href={socials.youtube}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Ir para o Youtube da HowStore"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </S.Socials>
          </S.Left>

          <S.Right>
            <S.LinksColumn>
              <h3>Navegação</h3>
              <ul>
                <li>
                  <a href={trustPilot} target="_blank" aria-label="Ir para avaliações da HowStore no Trustpilot">
                    Avaliações
                  </a>
                </li>
                <li>
                  <Link to="/categorias" aria-label="Ir para listagem de categorias">Categorias</Link>
                </li>
                <li>
                  <a href="/produtos" aria-label="Ir para listagem de produtos">Produtos</a>
                </li>
              </ul>
            </S.LinksColumn>
            <S.LinksColumn>
              <h3>Ajuda</h3>
              <ul>
                <li>
                  <a href={socials.discord} target="_blank" aria-label="Ir para o suporte no Discord da Howstore">Suporte</a>
                </li>
                <li>
                  <Link to="/termos" aria-label="Ir para os termos de uso">Termos de uso</Link>
                </li>
                <li>
                  <Link to="/termos" aria-label="Ir para os termos de uso">Política de Privacidade</Link>
                </li>
              </ul>
            </S.LinksColumn>
          </S.Right>
        </S.ContentWrapper>
      </Container>

      <S.Bottom>
        <p>
          © 2025 | All Rights Reserved | CNPJ:
          <strong>55.213.176/0001-13</strong> / HowStore LTDA
        </p>
      </S.Bottom>
    </S.FooterWrapper>
  );
};
